<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
            <span>Details in below Table are Inactive in Sales/Expense Tables For Calculation</span>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button
              class="pull-right ml-1 mt-1"
              :variant="
                Filter.particularFilter ||
                Filter.headFilter ||
                Filter.isDeletedFilter ||
                Filter.billingTypeFilter ||
                Filter.isActiveFilter ||
                Filter.isExpInvFilter ||
                Filter.createdAtRange.startDate ||
                Filter.createdAtRange.endDate
                  ? 'outline-danger'
                  : 'outline-primary'
              "
              :class="' ml-4' + visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
              style="font-size: 0.675rem"
              >{{
                Filter.particularFilter ||
                Filter.headFilter ||
                Filter.isDeletedFilter ||
                Filter.billingTypeFilter ||
                Filter.isActiveFilter ||
                Filter.isExpInvFilter ||
                Filter.createdAtRange.startDate ||
                Filter.createdAtRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button
            >
            <b-button
              class="pull-right ml-1 mt-1"
              v-if="getExpInvHead.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getExpInvHead', 'Export As Excel')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
            <b-button
              variant="primary"
              @click="openHeadModal('', 'Add')"
              id="addButtonLoader"
              size="sm"
              style="font-size: 0.675rem"
              >Add</b-button
            >
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Exp/Inv type</label>

                  <model-list-select
                    :list="ExpInvTypeList"
                    v-model="Filter.isExpInvFilter"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    @input="getExpInvHeadDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker
                    :always-show-calendars="showCal"
                    v-model="Filter.createdAtRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getExpInvHeadDash('Normal', '0', '0', '1', '1')"
                  ></date-range-picker>
                </b-col>

                <b-col md="3">
                  <label>Status</label>
                  <model-list-select
                    :list="StatusList"
                    v-model="Filter.isActiveFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Clear Status"
                    @input="getExpInvHeadDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Delete Status</label>

                  <model-list-select
                    :list="DeleteStatusList"
                    v-model="Filter.isDeletedFilter"
                    option-value="inv"
                    option-text="int"
                    placeholder="Select Billing Status"
                    @input="getExpInvHeadDash('Normal', '0', '0', '1', '1')"
                  ></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Particular Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Particular Filter"
                    id="particularFilter"
                    name="particularFilter"
                    autocomplete="off"
                    v-model="Filter.particularFilter"
                    @input="getExpInvHeadDash('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Head Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Head Filter"
                    id="headFilter"
                    name="headFilter"
                    autocomplete="off"
                    v-model="Filter.headFilter"
                    @input="getExpInvHeadDash('Normal', '0', '0', '1', '1')"
                  ></b-form-input>
                </b-col>

                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllUserList']"
                    id="createdByFilter"
                    @input="getExpInvHeadDash('Normal', '0', '0', '1', '1')"
                    v-model="Filter.createdByFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Created User"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Updated By User </b>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllUserList']"
                    id="updatedByFilter"
                    @input="getExpInvHeadDash('Normal', '0', '0', '1', '1')"
                    v-model="Filter.updatedByFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Updated User"
                  ></model-list-select>
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="ml-1 pull-right"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table
                show-empty
                stacked="md"
                responsive
                :items="getExpInvHead"
                :fields="ExpInvFields"
                primary-key="id_email_section"
                :per-page="pagination.perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
                class="position-relative"
              >
                <!-- Default Row Data -->
                <template slot="SN" slot-scope="row0">
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>
                <template slot="rem_head_is_exp_inv" slot-scope="row1">
                  {{
                    row1.item.rem_head_is_exp_inv == 0
                      ? "None"
                      : row1.item.rem_head_is_exp_inv == 1
                      ? "Invoice"
                      : row1.item.rem_head_is_exp_inv == 2
                      ? "Expense"
                      : ""
                  }}
                </template>
                <template slot="rem_head_is_active" slot-scope="row1">
                  <div :id="'row' + row1.item.rem_head_id">
                      <md-switch
                        :id="'approval' + row1.item.rem_head_id"
                        name="approval"
                        class="md-primary"
                        :value="row1.item.rem_head_is_active == 1 ? true : false"
                        @change="activateUser(row1.item)"
                      >
                        <h6>
                          <br />
                          <b-badge
                            :variant="row1.item.rem_head_is_active == 1 ? 'success' : 'danger'"
                            >{{
                              row1.item.rem_head_is_active == 1 ? "Active" : "In-Active"
                            }}</b-badge
                          >
                        </h6>
                      </md-switch>
                    </div>
                   
                  <!-- {{ row1.item.rem_head_is_active == 1 ? "Active" : "In-ACtive" }} -->
                </template>
                <template slot="rem_head_created_at" slot-scope="row1">
                  <b-button
                    variant="primary"
                    @click="openHeadModal(row1.item, 'Update')"
                    id="addButtonLoader"
                    size="sm"
                    style="font-size: 0.675rem"
                    >View</b-button
                  >
                  <strong>Created By:</strong>
                  <span v-if="row1.item.rem_head_cu_relation"
                    >{{ row1.item.rem_head_cu_relation.employeeName }}<br
                  /></span>
                  <strong>Created Date:</strong> {{ row1.item.rem_head_created_at }}<br />
                  <strong v-if="row1.item.rem_head_uu_relation">Updated By:</strong>
                  <span v-if="row1.item.rem_head_uu_relation"
                    >{{ row1.item.rem_head_uu_relation.employeeName }}<br
                  /></span>
                  <strong>Updated Date:</strong> {{ row1.item.rem_head_updated_at }}<br />
                </template>
              </b-table>
            </div>
            <div>
              <b-pagination
                limit="25"
                align="center"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="totalData"
                @change="onPageChange($event)"
              ></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>

    <!-- Head Modal Added By Priyanshu Singh Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Head-modal"
      hide-footer
      :title="ModalType + ' Head'"
    >
      <b-row class="justify-content-center">
        <b-col md="4">
          <label>Exp/Inv type</label>

          <model-list-select
            :list="ExpInvTypeList"
            v-model="headModal.rem_head_is_exp_inv"
            option-value="DVal"
            option-text="DText"
            placeholder="Select"
            @input="changeType(headModal)"
          ></model-list-select>
        </b-col>
        <b-col md="4">
          <label>Particular </label>
          <model-list-select
            :isDisabled="(headModal.rem_head_is_exp_inv == '0' || headModal.rem_head_is_exp_inv == '')"
            :list="
              headModal.rem_head_is_exp_inv == '1'
                ? $store.getters['commonDropdownMaster/getAllInvoiceParticularDDList']
                : headModal.rem_head_is_exp_inv == '2'
                ? $store.getters['commonDropdownMaster/getAllExpenseParticularDDList']
                : []
            "
            @input="getParticularsName(headModal)"
            v-model="headModal.rem_head_particular"
            option-value="label"
            option-text="label"
            placeholder="Select Particular"
          ></model-list-select>
          <!-- @input="getParticularsName(headModal)" -->
          <span class="error" v-if="!headModal.rem_head_particular">{{
            errorHeadList.rem_head_particular
          }}</span>
        </b-col>

        <b-col md="4">
          <label>Head <span class="error">*</span></label>

          <model-list-select
            :isDisabled="!headModal.rem_head_particular"
            :list="
              headModal.rem_head_is_exp_inv == '1'
                ? $store.getters['commonDropdownMaster/getAllInvoiceHeadDDList']
                : headModal.rem_head_is_exp_inv == '2'
                ? $store.getters['commonDropdownMaster/getAllExpenseHeadDDList']
                : []
            "
            @input="getParticulars(headModal)"
            v-model="headModal.rem_head_title"
            option-value="label"
            option-text="label"
            placeholder="Select Head"
          ></model-list-select>
          <!-- @input="getParticulars(headModal)" -->
          <span class="error" v-if="!headModal.rem_head_title">{{
            errorHeadList.rem_head_title
          }}</span>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col class="my-3 text-center">
          <b-button
            v-if="headModal.rem_head_id<=0 || headModal.rem_head_id==''"
            :disabled="!headModal.rem_head_title || !headModal.rem_head_particular || !headModal.rem_head_is_exp_inv"
            variant="outline-primary"
            @click="addHead"
            id="addButtonLoader"
            size="sm"
            >Save</b-button
          >
          <b-button variant="outline-danger" class="ml-2" size="sm" @click="hideHeadModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
        <b-row>
        <b-col md="12"  v-if="(headModal.rem_head_is_exp_inv == '1' || headModal.rem_head_is_exp_inv == '2') && headModal.rem_head_particular">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Inv Type</th>
                <th>Inv No</th>
                <th>Ledger Group</th>
                <th>Buyer</th>
                <th>Seller</th>
              </tr>
            </thead>
            <tbody v-if="headModal.rem_head_is_exp_inv == '1'">
              <tr 
                v-for="(inv_item, inv_index) in $store.getters['commonDropdownMaster/getAllInvoiceHeadDDList']"
                :key="inv_index"
                >
                <td>{{inv_item.DocDtls_Typ}}</td>
                <td>{{inv_item.DocDtls_No}}</td>
                <td>{{inv_item.ledger_group}}</td>
                <td>{{inv_item.BuyerDtls_LglNm}}</td>
                <td>{{inv_item.SellerDtls_LglNm}}</td>
              </tr>
            </tbody>
            <tbody v-if="headModal.rem_head_is_exp_inv == '2'">
              <tr 
                v-for="(exp_item, exp_index) in $store.getters['commonDropdownMaster/getAllExpenseHeadDDList']"
                :key="exp_index"
                >
                <td>{{exp_item.docDtls_Typ}}</td>
                <td>{{exp_item.docDtls_No}}</td>
                <td>{{exp_item.ledger_group}}</td>
                <td>{{exp_item.buyerDtls_LglNm}}</td>
                <td>{{exp_item.sellerDtls_LglNm}}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>

    </b-modal>
    <!-- Head Modal Added By Priyanshu Singh Start -->

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import ClientUserService from "../../services/ClientUserService";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    console.log(
      "this.$router.history.current.fullPath=>",
      this.$router.history.current.fullPath
    );

    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );

    this.$store.dispatch("commonDropdownMaster/setAllInvHeadDDList", {
      itemCode: "GET_USERLIST_Data",
      pageSize: 2000,
      page: 1,
      isAll: 0,
      isSelectedColumn: 0,
      BookingStatus: 1,
      is_doc_type_unique: 1,
    });

    this.$store.dispatch("commonDropdownMaster/setAllInvParticularDDList", {
      itemCode: "GET_USERLIST_Data",
      pageSize: 2000,
      page: 1,
      isAll: 0,
      isSelectedColumn: 0,
      BookingStatus: 1,
      is_doc_type_unique: 1,
      docDtlsTyp: "", //Purchase-Noida
    });

    this.$store.dispatch("commonDropdownMaster/setAllExpHeadDDList", {
      itemCode: "GET_USERLIST_Data",
      pageSize: 2000,
      page: 1,
      isAll: 0,
      isSelectedColumn: 0,
      BookingStatus: 1,
      is_doc_type_unique: 1,
    });

    this.$store.dispatch("commonDropdownMaster/setAllExpParticularDDList", {
      itemCode: "GET_USERLIST_Data",
      pageSize: 2000,
      page: 1,
      isAll: 0,
      isSelectedColumn: 0,
      BookingStatus: 1,
      is_doc_type_unique: 1,
      docDtlsTyp: "", //Purchase-Noida
    });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getExpInvHeadDash("Normal", "0", "0", "1", "1");
    }
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},
  data() {
    return {
      ModalType: "Add",
      // Added vy Priyanshu Singh Start
      headModal: {
        rem_head_id: "",
        rem_head_title: "",
        rem_head_particular: "",
        fk_exp_part_id: "",
        fk_inv_part_id: "",
        fk_exp_head_id: "",
        fk_inv_head_id: "",
        rem_head_is_exp_inv: "0",
      },
      HeadError: ["Please Enter Title", "Please Enter Particulars"],
      errorHeadList: {
        rem_head_title: "",
        rem_head_particular: "",
      },

      // Added vy Priyanshu Singh End

      isClientKycDash:
        this.$route.path == this.$router.history.current.fullPath ? true : false,
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getExpInvHead: [],
      totalData: 0,

      ExpInvFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "rem_head_title",
          mainkey: "rem_head_title",
          label: "Head",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "rem_head_particular",
          mainkey: "rem_head_particular",
          label: "Particular",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "rem_head_is_exp_inv",
          mainkey: "rem_head_is_exp_inv",
          label: "Type",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "rem_head_is_active",
          mainkey: "rem_head_is_active",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "rem_head_created_at",
          mainkey: "rem_head_created_at",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      StatusList: [
        {
          inv: "0",
          int: "In-Active",
        },
        {
          inv: "1",
          int: "Active",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      ExpInvTypeList: [
        {
          DVal: "0",
          DText: "None",
        },
        {
          DVal: "1",
          DText: "Invoice",
        },
        {
          DVal: "2",
          DText: "Expense",
        },
        {
          DVal: "2",
          DText: "All",
        },
      ],

      DeleteStatusList: [
        {
          inv: "1",
          int: "Deleted",
        },
        {
          inv: "0",
          int: "Not-Deleted",
        },
        {
          inv: "",
          int: "All",
        },
      ],

      Filter: {
        isExpInvFilter: "",

        isDeletedFilter: "0",
        isActiveFilter: "1",
        particularFilter: "",
        headFilter: "",

        createdByFilter: "",
        updatedByFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      createdAtRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      validate: true,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {},
  watch: {},
  methods: {
    activateUser(item) {
      this.itemObj = item;

      this.itemObj.rem_head_is_active = this.itemObj.rem_head_is_active == 1 ? 0 : 1;
      let paylod = {
        tableName: "m_exp_inv_heads_part",
        tableId: "rem_head_id",
        tableIsActive: "rem_head_is_active",
        value1: this.itemObj.rem_head_is_active,
        tableVal: item.rem_head_id,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getExpInvHeadDash("Normal", "0", "0", "1", "1");
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    changeType(headModal){
      if(headModal.rem_head_is_exp_inv == '0' || headModal.rem_head_is_exp_inv == ''){
        this.headModal= {
          rem_head_title: "",
          rem_head_particular: "",
          fk_exp_part_id: "",
          fk_inv_part_id: "",
          fk_exp_head_id: "",
          fk_inv_head_id: "",
        };
      }

    },
    getParticulars(headModal) {
      if (headModal.rem_head_is_exp_inv == 1) {
        //Invoice
        let getHeadArr = this.$store.getters[
          "commonDropdownMaster/getAllInvoiceHeadDDList"
        ].filter((x) => {
          return x.label == headModal.rem_head_title;
        });
        if (getHeadArr.length > 0) {
          this.headModal.fk_inv_head_id = getHeadArr[0].value;
        }
      } else if (headModal.rem_head_is_exp_inv == 2) {
        //Expense

        let getHeadArr = this.$store.getters[
          "commonDropdownMaster/getAllExpenseHeadDDList"
        ].filter((x) => {
          return x.label == headModal.rem_head_title;
        });
        if (getHeadArr.length > 0) {
          this.headModal.fk_exp_head_id = getHeadArr[0].value;
        }
      }

      // if (headModal.rem_head_is_exp_inv == 1) {
      //   //Invoice
      //   this.$store.dispatch("commonDropdownMaster/setAllInvParticularDDList", {
      //     itemCode: "GET_USERLIST_Data",
      //     pageSize: 2000,
      //     page: 1,
      //     isAll: 0,
      //     isSelectedColumn: 0,
      //     BookingStatus: 1,
      //     is_doc_type_unique: 1,
      //     docDtlsTyp: headModal.rem_head_title, //Purchase-Noida
      //   });
      //   let getHeadArr = this.$store.getters[
      //     "commonDropdownMaster/getAllInvoiceHeadDDList"
      //   ].filter((x) => {
      //     return x.label == headModal.rem_head_title;
      //   });
      //   if (getHeadArr.length > 0) {
      //     this.headModal.fk_inv_head_id = getHeadArr[0].value;
      //   }
      // } else if (headModal.rem_head_is_exp_inv == 2) {
      //   //Expense
      //   this.$store.dispatch("commonDropdownMaster/setAllExpParticularDDList", {
      //     itemCode: "GET_USERLIST_Data",
      //     pageSize: 2000,
      //     page: 1,
      //     isAll: 0,
      //     isSelectedColumn: 0,
      //     BookingStatus: 1,
      //     is_doc_type_unique: 1,
      //     docDtlsTyp: headModal.rem_head_title, //Purchase-Noida
      //   });
      //   let getHeadArr = this.$store.getters[
      //     "commonDropdownMaster/getAllExpenseHeadDDList"
      //   ].filter((x) => {
      //     return x.label == headModal.rem_head_title;
      //   });
      //   if (getHeadArr.length > 0) {
      //     this.headModal.fk_exp_head_id = getHeadArr[0].value;
      //   }
      // }
    },
    getParticularsName(headModal) {
      // this.headModal.rem_head_title = "";
      if (this.headModal.rem_head_is_exp_inv == 1) {
        //Invoice
        let headTitle = "";
        let getParticularArr = this.$store.getters[
          "commonDropdownMaster/getAllInvoiceParticularDDList"
        ].filter((x) => {
          return x.label == headModal.rem_head_particular;
        });
        if (getParticularArr.length > 0) {
          this.headModal.fk_inv_part_id = getParticularArr[0].value;
          headTitle = getParticularArr[0].reverse_tally_billing_relation.DocDtls_Typ;
          // headTitle = getParticularArr[0].reverse_tally_billing_relation.DocDtls_Typ;
        }
        this.$store.dispatch("commonDropdownMaster/setAllInvHeadDDList", {
          itemCode: "GET_USERLIST_Data",
          pageSize: 2000,
          page: 1,
          isAll: 0,
          isSelectedColumn: 0,
          BookingStatus: 1,
          is_doc_type_unique: 1,
          // docDtlsTyp: headTitle,
          particulars: headModal.rem_head_particular,
        });
      } else if (this.headModal.rem_head_is_exp_inv == 2) {
        //Expense
        let headTitle = "";
        let getParticularArr = this.$store.getters[
          "commonDropdownMaster/getAllExpenseParticularDDList"
        ].filter((x) => {
          return x.label == headModal.rem_head_particular;
        });
        if (getParticularArr.length > 0) {
          this.headModal.fk_exp_part_id = getParticularArr[0].value;
          headTitle = getParticularArr[0].tally_billing_expense_relation.docDtls_Typ;
        }
        this.$store.dispatch("commonDropdownMaster/setAllExpHeadDDList", {
          itemCode: "GET_USERLIST_Data",
          pageSize: 2000,
          page: 1,
          isAll: 0,
          isSelectedColumn: 0,
          BookingStatus: 1,
          is_doc_type_unique: 1,
          // docDtlsTyp: headTitle,
          particulars: headModal.rem_head_particular,
        });
      }
    },
    validateHead() {
      let validate_new = true;
      Object.keys(this.errorHeadList).map((x, index) => {
        if (this.headModal[x] == "") {
          this.errorHeadList[x] = this.HeadError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    clearPayload() {
      this.headModal = {
        rem_head_id: "",
        rem_head_title: "",
        rem_head_particular: "",
        fk_exp_part_id: "",
        fk_inv_part_id: "",
        fk_exp_head_id: "",
        fk_inv_head_id: "",
        rem_head_is_exp_inv: "0",
      };
    },

    async openHeadModal(item, type) {
      this.clearPayload();
      this.ModalType = type;
      if (item.rem_head_id) {
        this.headModal = item;
        this.headModal.rem_head_is_exp_inv = item.rem_head_is_exp_inv.toString();
        
        // this.getParticulars(this.headModal);
        // this.getParticularsName(this.headModal);
        try {
          // Await the completion of store actions and introduce delay
          await this.getParticulars(this.headModal);
          await this.delay(2000); // Introduce 2 second delay
          this.getParticularsName(this.headModal);
        } catch (error) {
          console.error("Error dispatching store actions:", error);
        }
      }
      this.isLoading = false;
      this.$refs["Head-modal"].show();
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    hideHeadModal() {
      this.clearPayload();
      this.$refs["Head-modal"].hide();
      this.isLoading = false;
    },
    addHead() {
      this.validateHead();
      if (this.validate != false) {
        NodeLockPannelService.saveExpInvHead(this.headModal)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log("data PS=>", data.data);
            if (status == 200 && data) {
              this.clearPayload();
              this.hideHeadModal();
              this.getExpInvHeadDash("Normal", "0", "0", "1", "1");
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on addHead Error: ", error);
          });
      }
    },
    clearFilter() {
      this.Filter = {
        isExpInvFilter: "",

        isDeletedFilter: "0",
        isActiveFilter: "1",
        particularFilter: "",
        headFilter: "",

        createdByFilter: "",
        updatedByFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getExpInvHeadDash("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.createdAtRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    getExpInvHeadDash(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.totalData = 0;
      this.getExpInvHead = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getExpInvHead",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,

        isAll: 0,
        isSelectedColumn: 0,
        generateExcel: this.generateExcel,
        Filter: this.Filter,

        isExpInvFilter: this.Filter.isExpInvFilter,
        isDeletedFilter: this.Filter.isDeletedFilter,
        isActiveFilter: this.Filter.isActiveFilter,
        particularFilter: this.Filter.particularFilter,
        headFilter: this.Filter.headFilter,
        createdByFilter: this.Filter.createdByFilter,
        updatedByFilter: this.Filter.updatedByFilter,
        // createdAtRange: this.Filter.createdAtRange,
        endDate: this.Filter.createdAtRange.endDate,
        startDate: this.Filter.createdAtRange.startDate,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllExpInvHeadList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data.data);
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              if (data.data.length > 0) {
                this.totalData = data.meta.totalExpInvs;
                this.getExpInvHead = data.data;
              }
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "ExpInvHeadsReports.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getExpInvHeadDash("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.meta.totalExpInvs;
                this.getExpInvHead = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getExpInvHead Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() {},
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getExpInvHeadDash("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getExpInvHeadDash("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getExpInvHeadDash("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      console.log("event=>", event);
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getExpInvHeadDash("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// expInvHeads.vue?5a7bfeec